import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const FirebaseCredentialList = Loadable(
  lazy(() => import("features/notification/credentialsFirebase/components/List"))
);
const FirebaseCredentialPage = Loadable(
  lazy(() => import("features/notification/credentialsFirebase/components/Page"))
);

const routes = {
  path: "firebase",
  children: [
    { path: "", element: <FirebaseCredentialList /> },
    { path: "add", element: <FirebaseCredentialPage /> },
    { path: "edit/:credentialID?", element: <FirebaseCredentialPage /> },
  ],
};

export default routes;
